import React, { useRef } from 'react';
import './design.css';
import { useDrag, useDrop } from 'react-dnd';

const ItemTypes = {
  CARD: 'question',
};

const Question = (props) => {
  const { 
    id, index, currentPage, moveQuestion, question, className, 
    onClick, clone, remove, callConfirmation, copyToSingleAndViceVersa, hideQuestion 
  } = props;
  
  const ref = useRef(null);
  const [{ isDragging }, drag] = useDrag({
    type: 'question',
    item: () => ({
      id: question.id,
      index,
      pageIndex: currentPage,
      question
    }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const [, drop] = useDrop({
    accept: 'question',
    hover(item, monitor) {
      if (!ref.current) return;
      const dragIndex = item.index;
      const dragPageIndex = item.pageIndex;
      const hoverIndex = index;
      const hoverPageIndex = currentPage;

      if (dragIndex === hoverIndex && dragPageIndex === hoverPageIndex) return;

      const hoverBoundingRect = ref.current.getBoundingClientRect();
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      const clientOffset = monitor.getClientOffset();
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;

      if (!moveQuestion) return;

      moveQuestion(dragPageIndex, dragIndex, hoverPageIndex, hoverIndex);
      item.index = hoverIndex;
      item.pageIndex = hoverPageIndex;
    },
  });

  drag(drop(ref));

  // Determine if the question is hidden
  const isHidden = question.isHide ?? false;

  // Toggle hide/unhide
  const handleHideToggle = (e) => {
    e.stopPropagation();
    const action = isHidden ? "unhide" : "hide";
    // if (callConfirmation) {
     
        hideQuestion && hideQuestion(currentPage, index, !isHidden);
    //   });
    // } else {
    //   hideQuestion && hideQuestion(currentPage, index, !isHidden);
    // }
  };

  return (
    <div 
      ref={ref}
      style={{ opacity: isDragging ? 0.5 : 1 }}
      className={className}
      onClick={() => {
        props.setActiveHeaderFooter('question');
        onClick({ pageIndex: currentPage, questionIndex: index });
      }}
    >
      <div className="question-label">
        {/* Drag handle */}
        <i 
          className="fa fa-arrows drag-handle hidden-icon"
          style={{ marginRight: 4, cursor: 'move', opacity: 0.6, marginLeft: 3 }}
          onMouseDown={(e) => e.stopPropagation()}
        />

        {/* Error icon */}
        {question.errorStatus && (
          <i style={{ color: '#D32F2F', marginRight: 3 }} className="fa fa-exclamation-circle" />
        )}

        {/* Question type icon */}
        <i className={`${question?.selectedType?.icon} icon`} style={{ marginRight: 3 }} />

        {/* Question text */}
        <div className="question-text">
          {question.tempId}.{question.questionText}
        </div>

        {/* Clone */}
        <i 
          className="fa fa-clone hidden-icon" 
          style={{ marginLeft: 5, color: '#1F3BB3' }}
          onClick={(e) => { e.stopPropagation(); clone(e, index, currentPage); }}
        />

        {/* Delete */}
        <i 
          className="fa-regular fa-trash-can hidden-icon"
          style={{ marginLeft: 5, color: '#D32F2F' }}
          onClick={(e) => remove(e, index, currentPage)}
        />

        {/* Hide/Unhide */}
        <i 
          className={`fa ${isHidden ? "fa-eye-slash" : "fa-eye"} hidden-icon`} 
          style={{ marginLeft: 5, color: '#202020ff', cursor: 'pointer' }}
          onClick={handleHideToggle}
        />
      </div>
    </div>
  );
};


export default Question;